import { DecimalPipe } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LetregisterService } from '@features/letregister/letregister.service';
import { LetsikringRevision } from '@features/letregister/letsikring-revision.model';
import { LetsikringRisiko } from '@features/letregister/letsikring-risiko.model';
import { DetailRowComponent } from '@shared/detail-row/detail-row.component';
import { InputNumber } from 'primeng/inputnumber';
import { InputText } from 'primeng/inputtext';
import { Select } from 'primeng/select';

@Component({
  selector: 'app-letsikring-til-selvstaendige',
  imports: [
    DecimalPipe,
    ReactiveFormsModule,
    InputText,
    InputNumber,
    Select,
    DetailRowComponent,
  ],
  templateUrl: './letsikring-til-selvstaendige.component.html',
  styleUrl: './letsikring-til-selvstaendige.component.css',
})
export class LetsikringTilSelvstaendigeComponent {
  form = input.required<FormGroup>();
  editMode = input.required<boolean>();
  revision = input.required<LetsikringRevision>();
  LetregisterService = inject(LetregisterService);
  selectTilknyttet = output<LetsikringRisiko>();
  selectLivrente = output();

  onClickTilknyttet(tilknyttet: LetsikringRisiko) {
    this.selectTilknyttet.emit(tilknyttet);
  }

  onClickLivrente() {
    this.selectLivrente.emit();
  }

  tegningsmaadeOptions = [{ value: 'Privat' }, { value: 'Arbejdsgiver' }];

  firmaTypeOptions = [
    { text: 'Anpartsselskab', value: 'Anpartsselskab' },
    { text: 'Aktieselskab', value: 'Aktieselskab' },
    { text: 'Virksomhed', value: 'Virksomhed' },
    { text: 'Enkeltmandsvirksomhed', value: 'Enkeltmandsvirksomhed' },
    { text: 'Kommanditselskab', value: 'Kommanditselskab' },
    { text: 'InteressentSelskab', value: 'InteressentSelskab' },
    {
      text: 'PersonligtEjetMindreVirksomhed',
      value: 'PersonligtEjetMindreVirksomhed',
    },
    {
      text: 'AnpartsselskabMedBegraensetAnsvar',
      value: 'AnpartsselskabMedBegraensetAnsvar',
    },
    { text: 'Ivaerksaetterselskab', value: 'Ivaerksaetterselskab' },
    { text: 'Partnerselskab', value: 'Partnerselskab' },
    {
      text: 'FilialAfUdenlandskAktieselskabKommanditakties',
      value: 'FilialAfUdenlandskAktieselskabKommanditakties',
    },
    {
      text: 'FilialAfUdenlandskAnpartsselskabEllerSelskab',
      value: 'FilialAfUdenlandskAnpartsselskabEllerSelskab',
    },
    { text: 'UkendtType', value: 'UkendtType' },
    { text: 'SelskabMedBegraensetAnsvar', value: 'SelskabMedBegraensetAnsvar' },
  ];

  firmaRelationsTypeOptions = [
    { text: 'Ejer', value: 'Ejer' },
    { text: 'Ansat', value: 'Ansat' },
  ];
}
